// @flow
import React from 'react'
import CurrentCardContainer from './Carousel/CurrentCardContainer'
import LabeledInput from './AdInputs/LabeledInput'
import type { Configs } from '../types'
import CardSelectorContainer from './Carousel/CardSelectorContainer'
import type { CardControlVisibility } from './Carousel/Card'

type Props = {|
  errors: Array<string>,
  storeId: string,
  configs: Configs,
  hasAnyCards: boolean,
  cardControlVisibility: CardControlVisibility
|}

const t = {
  header: 'Карусель'
}

export default function Carousel(props: Props) {
  return (
    <LabeledInput
      header={t.header}
      errors={props.errors}
      input={
        <div>
          <CardSelectorContainer storeId={props.storeId} />
          {props.hasAnyCards && (
            <CurrentCardContainer
              storeId={props.storeId}
              configs={props.configs}
              cardControlVisibility={props.cardControlVisibility}
            />
          )}
        </div>
      }
    />
  )
}
